/*!

=========================================================
* Paper Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Card, CardTitle, CardHeader, CardBody, Row, Col } from "reactstrap";	// reactstrap components

class BatteryWatch extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			password: null
		};
	}

	render() {
		return (
		  <>
			<div className="content">
			  <Row>
				<Col md="12">
					<h1> Battery Watcher </h1>
				</Col>
			  </Row>

			  <Card>
				<CardHeader>
					  <h5 className="title"> Software Download </h5>
				</CardHeader>
				<CardBody>

				  <Row>
				  <Col lg="3">
				  </Col>

				  <Col lg="4">
				  <Row>
					<a href="https://beccue.com/BatteryWatch-latest.php"> Latest version of BatteryWatch for <b>Windows</b> </a>
				  </Row>

				  <Row>
					<a href="http://peregrine-llc.com/downloads/batterywatch.dmg"> Latest version of BatteryWatch for <b>Mac</b> </a>
				  </Row>

				  <Row>
					<a href="http://peregrine-llc.com/downloads/batterywatch"> Latest version of BatteryWatch for <b>Linux</b> </a>
				  </Row>
				  </Col>
				  </Row>

				</CardBody>
			  </Card>

			  <Card>
				<CardBody>
				<CardHeader>
                  <CardTitle tag="h5"> Wemo Hardware </CardTitle>
                  <p className="card-category"> Wemo is the only hardware needed and is easiest to use </p>
				</CardHeader>
				<Row>
				  <Col lg="3">
					<a target="_blank" rel="noopener noreferrer" href="https://www.amazon.com/gp/product/B01NBI0A6R">
						<img alt="Simplest compatible hardware is using this Wemo" src="/wemo.jpg" height="200" />
					</a>
				  </Col>

				  <Col lg="4">
					<a target="_blank" rel="noopener noreferrer" href="https://www.amazon.com/gp/product/B01NBI0A6R"> Simplest compatible hardware is using this Wemo </a>
				  </Col>

				  <Col lg="4">
				  	<ul>
						<li>
							Connect Wemo to your network using the app like normal.
						</li>
						<li>
							Find Wemo IP either from your router's info <i><b>or</b></i>
							<br/>
							in the <i>Settings ... Hardware Info</i> of the Wemo App
						</li>
						<li>
							Put the IP of the Wemo into the Configure page of the BatteryWatcher app
						</li>
				  	</ul>
				  </Col>
				</Row>

				</CardBody>
			  </Card>

			  <Card>
				<CardBody>
				<CardHeader>
					  <CardTitle tag="h5"> Sonoff Hardware </CardTitle>
					  <p className="card-category">
					  Sonoff hardware like this can be used instead of Wemo
					  <br />
					  if loaded with custom software that responds to MQTT commands
					  </p>
				</CardHeader>

				  <Row>
				  <Col lg="3">
					<a target="_blank" rel="noopener noreferrer" href="https://www.amazon.com/Sonoff-Compatible-Assistant-Supporting-Required/dp/B07YXVWC3Y/">
						<img alt="Where to buy the Sonoff S31" src="/sonoff-s31.jpg" height="100" />
					</a>
				  </Col>

				  <Col lg="4">
					<a target="_blank" rel="noopener noreferrer" href="https://www.amazon.com/Sonoff-Compatible-Assistant-Supporting-Required/dp/B07YXVWC3Y/"> Where to buy the Sonoff S31 </a>
				  </Col>

				  <Col lg="4">

				  	<Row>
					<a target="_blank" rel="noopener noreferrer" href="https://www.phreakmonkey.com/2018/01/sonoff-s31-disassemble-and-flash.html"> How to put your own software into the Sonoff S31 </a>
				  	</Row>

				  	<Row>
					<a target="_blank" rel="noopener noreferrer" href="https://www.amazon.com/uxcell-PL2303HX-Transfer-Serial-Adapter/dp/B079Z94WS2/"> Tool used to load the software into the Sonoff S31 </a>
				  	</Row>

				  	<Row>
					<a href="https://github.com/arendst/Tasmota/releases/download/v8.2.0/tasmota.bin"> Software to load into the Sonoff S31 </a>
				  	</Row>
				  </Col>
				  </Row>
				</CardBody>
			  </Card>
			</div>
		  </>
		);
	}
}

export default BatteryWatch;
